import { Theme } from "./theme.model";

export const LonaciTheme: Theme =  {
  name: 'lonaci',
  common: 'SPORTCASH',
  properties: {
    '--app-color-base': '#17633b',
    '--app-color-heading-5': '#cbf9e0',
    '--app-color-white': '#fff',
    '--app-input-bg': '#ffffff',
    '--app-input-border-bg': '#DDDDDD',
    '--app-input-placeholder-bg': '#cccccc',
    '--app-color-primary': '#fff',
    '--app-color-primary-tint': '#dedede',
    '--app-color-primary-tint-0': '#e6e6e6',
    '--app-color-primary-tint-2': '#bbbbbb',
    '--app-color-primary-tint-3': '#c3c3c3',
    '--app-color-primary-tint-5': '#d4d4d4',
    '--app-color-secondary': '#000',
    '--app-color-danger': '#D50000',
    '--app-color-tertiary': '#64c388',
    '--app-color-tertiary-tint': '#eb862c',
    '--app-color-header-about': '#00ff75',
    "--app-color-promotions": "#fff",
    "--app-color-lexique": "#fff",
    "--app-color-checkbox-input-border-unchecked": "#777676e5",
    "--app-color-checkbox-input-border": "#fff",
    "--app-inactive-tab-color": "#999999",
    "--app-form-link-color": "#161512",
    "--app-partner-input-bg": "#F8F8F8",

    // background colors
    '--app-background-grey': '#EEEEEE',
    '--app-background-grey-tint': '#5d5d5d ',
    '--app-background-base': '#fff',
    '--app-background-primary': '#176334',
    '--app-background-primary-tint': '#009d48',
    '--app-background-primary-tint-1': '#2DB76C',
    '--app-background-four-tint': '#037b3a',
    '--app-background-four-tint-1': '#00ff61',
    '--app-background-tertiary': '#c38411',
    '--app-background-tertiary-tint': '#154e2b',
    '--app-background-tertiary-tint-1': '#ff9900',
    '--app-background-tertiary-dark': '#2f2f2f',
    // '--app-background-tertiary-tint': '#2f2f2f',
    '--app-background-secondary-tint': '#eb862c',
    '--app-background-secondary-tint-1': '#c4640f',
    '--app-background-primary-tint-contrast': '#ccbfbf',
    '--app-btn-default-bg': '#DDDDDD',
    '--app-btn-default-bg-hover': 'rgba(68, 68, 68, 0.25)',
    '--app-back-btn-bg': 'rgba(129, 128, 128, 0.1)',
    '--app-btn-default-txt-color': '#3e3e3e',
    '--app-background-promotions': '#009d48',
    "--app-background-border-promotions": "#009d48",
    "--app-background-cmtJr": "#5d5d5d",
    "--app-background-lexique": "#5d5d5d",
    "--app-background-checkbox-input-unchecked": "#ffffffa4",
    "--app-background-checkbox-input": "#eb862c",
    "--app-step-default-bg": "#dddddd",
    "--app-step-default-txt-color": "black",
    "--app-step-active-bg": "#009D48",
    '--app-table-header-txt': '#777777',
    "--app-danger-bg": "#FF3030",
    "--app-danger-bg-2": "#FF5151",

    "--app-danger-bg-hover": "#E02828",
    "--app-danger-bg-light": "#FFF5F5",
    "--app-danger-border": "#FED7D7",
    "--app-danger-color": "#DC3545",
    "--app-danger-text-dark": "#721C24",
    "--app-success-color": "#28A745",
    "--app-color-text-primary": "#333333",
    "--app-color-text-secondary": "#666666",
    "--app-color-text-muted": "#6C757D",
    "--app-background-light": "#F8F9FA",

    // Warning colors
    "--app-warning-color": "#FFC107",
    "--app-warning-text-dark": "#856404",
    "--app-background-warning-light": "#FFF3CD",
    "--app-border-warning": "#FFEAA7",
    "--app-warning-bg": "#FFC107",
    "--app-warning-bg-hover": "#E0A800",

    // Info colors
    "--app-info-color": "#17A2B8",
    "--app-info-dark-color": "#0C5460",
    "--app-background-info": "#D1ECF1",
    "--app-border-info": "#BEE5EB"

  },
  socialMedia: {
    facebook: 'https://wwww.facebook.com/loterienationaledecotedivoire',
    twitter: 'https://x.com/LONACI_officiel',
    instagram: 'https://www.instagram.com/loterie_nationale_ci/',
    linkedin: '',
    telegram: '',
    youtube: 'https://www.youtube.com/@lonacitv',
    whatsapp: ''
  }
};
